/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_Ai_DescInputs */

const en_directory_submit_content_ai_desc = /** @type {(inputs: Directory_Submit_Content_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI crawls your site, writes the listing, and saves a draft to review.`)
};

const zh_directory_submit_content_ai_desc = /** @type {(inputs: Directory_Submit_Content_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 抓取你的网站、撰写收录内容，并保存草稿供你确认。`)
};

/**
* | output |
* | --- |
* | "AI crawls your site, writes the listing, and saves a draft to review." |
*
* @param {Directory_Submit_Content_Ai_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_ai_desc = /** @type {((inputs?: Directory_Submit_Content_Ai_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_Ai_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_ai_desc(inputs)
	return zh_directory_submit_content_ai_desc(inputs)
});
export { directory_submit_content_ai_desc as "directory.submit.content.ai_desc" }